"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const react_dropzone_1 = require("react-dropzone");
const atoms_1 = require("../../atoms");
const DropZone = ({ onDrop, files, className, label, options }) => {
    var _a, _b;
    const handleDrop = react_1.useCallback((acceptedFiles, fileRejections, event) => {
        var _a;
        onDrop === null || onDrop === void 0 ? void 0 : onDrop(acceptedFiles, fileRejections, event);
        (_a = options === null || options === void 0 ? void 0 : options.onDrop) === null || _a === void 0 ? void 0 : _a.call(options, acceptedFiles, fileRejections, event);
    }, []);
    const { acceptedFiles, getRootProps, getInputProps, isDragActive } = react_dropzone_1.useDropzone({
        ...options,
        onDrop: handleDrop,
    });
    return (react_1.default.createElement("div", Object.assign({ className: clsx_1.default('min-h-48 flex flex-col items-center justify-center p-4 w-full dark:bg-gray-700 bg-white border-4 border-dashed rounded cursor-pointer transition transition-all duration-200', isDragActive ? 'border-highlight-400' : 'border-black-200', className) }, getRootProps()),
        react_1.default.createElement(atoms_1.AttachmentIcon, { className: clsx_1.default(' transition transition-all duration-200', isDragActive ? 'text-highlight-100' : 'text-gray-100 dark:text-gray-500', ((_a = (files !== null && files !== void 0 ? files : acceptedFiles)) === null || _a === void 0 ? void 0 : _a.length) > 0 ? 'h-12' : 'h-24') }),
        react_1.default.createElement("input", Object.assign({}, getInputProps())),
        react_1.default.createElement("span", { className: 'mb-3' }, label), (_b = (files !== null && files !== void 0 ? files : acceptedFiles)) === null || _b === void 0 ? void 0 :
        _b.map((file) => (react_1.default.createElement("span", { key: file.name }, file.name)))));
};
exports.default = DropZone;
